import { Col, InputField, Label, Row } from "client/CommonComponents"
import CompleteConfirmationPopup from "client/CommonComponents/DialogBox/CompleteConfirmationPopup"
import './AddEqClassCode.scss'
import ExistingList from "../ExistingList"

const AddEqClassCode = (props: any) => {
    const {
        ExistingDropDownValue,
        eqClassCode,
        eqClassDescription,
        handleOnChange,
        hideDialogComplete,
        PopupcontentComplete,
        removeItem,
        addEqClassCodeError,
        addEqClassDescriptionError,
        catalogItemValues
    } = props
    return (<Row>
        <Col xs={12} sm={12} className='mb-3'>
            <Label required data-attribute="AddEqClassCode_Default_Label">Eq Class Code</Label>
            <InputField
                placeholder="Enter Eq Class Code"
                value={eqClassCode ?? ''}
                onChange={(e: any) => handleOnChange(e, "Code")}
                className={addEqClassCodeError?.length ? "controlValidation" : ''}
             data-attribute="AddEqClassCode_Default_Input" />
            {addEqClassCodeError?.length ? <p className='validMessage'>{addEqClassCodeError}</p> : null}
        </Col>
        <Col xs={12} sm={12} className='mb-3'>
            <Label required data-attribute="AddEqClassCode_Default_Label_2">Eq Class Description</Label>
            <InputField
                placeholder="Enter Eq Class Description"
                value={eqClassDescription ?? ''}
                onChange={(e: any) => handleOnChange(e, "Description")}
                className={addEqClassDescriptionError?.length ? "controlValidation" : ''}
             data-attribute="AddEqClassCode_Default_Input_2" />
            {addEqClassDescriptionError?.length ? <p className='validMessage'>{addEqClassDescriptionError}</p> : null}
        </Col>
        <ExistingList ExistingDropDownValue={ExistingDropDownValue} removeItem={removeItem} catalogItemValues = {catalogItemValues} />
        <CompleteConfirmationPopup
            hideDialog={hideDialogComplete}
            onDismiss={PopupcontentComplete?.popupOutlinebtnOnclickComplete}
            Popupcontent={PopupcontentComplete}
            popupOutlinebtnOnclick={PopupcontentComplete?.popupOutlinebtnOnclickComplete}
            popupPrimarybtnOnclick={PopupcontentComplete?.popupPrimarybtnOnclick}
        />
    </Row>)
}

export default AddEqClassCode